<template>
<ul class="related-many">
  <li v-for="(item, ii) in value">
    <button class="btn btn-danger" @click.prevent="removeItem(ii)">
      <i :class="'fas fa-xmark'"></i>
    </button>
    <span class="value" v-if="dbfield?.cascade!='delete'">{{ value?.username || value?.name || value?.title || value?.uuid || value?.id }}</span>
    <DataForm v-if="dbfield?.cascade=='delete'" :params="{type}" :item="item" />
  </li>
  <li class="new">
    <button class="btn btn-primary" @click.prevent="addNew" v-if="dbfield?.cascade=='delete'"><i :class="'fas fa-plus'"></i></button>
    <button class="btn btn-primary" @click.prevent="selectItem" v-if="dbfield?.cascade!='delete'"><i :class="'fas fa-plus'"></i></button>
  </li>
</ul>
</template>

<script>
export default {
  props: ["modelValue", "field", "item", "field", "dbfield"],
  data: ()=>({
    value: [],
  }),
  watch: {
    value: {
      handler() {
        this.$emit("update:modelValue", this.value);
      },
    },
    modelValue: {
      handler() {
        this.value=this.modelValue || [];
      }, immediate: true,
    },
  },
  computed: {
    type() {
      return this.dbfield.target;
    },
    fieldDesc() {
      return this.stores.auth.typeDesc?.[this.type] ?? {};
    },
  },
  methods: {
    createLink(type) {
      return {
        name: "page",
        params: {
          path: [...this.$route.params.path, type],
        }
      }
    },
    addNew() {
      var newItem={};
      for(var field in this.fieldDesc) {
        if (field!=this.dbfield.name)
          newItem[field]=null;
      }
      this.value.push(newItem);
    },
    selectItem() {
      this.stores.callbacks.pushCallback((...args)=>this.select(...args));
      this.$router.push(this.createLink(this.dbfield.target));
    },
    select(item) {
//       this.stores.callbacks.popCallback();
      this.value.push(item);
      // TODO
    },
    removeItem(index) {
      this.value.splice(index, 1);
    },
  },
}
</script>
